module.exports = __webpack_public_path__ + "img/BRETAGNE_1.3842311f.webp";